import Vue from "vue";
import Vuex from "vuex";
import vuexI18n from "vuex-i18n";

import * as actions from "@/store/modules/actions";
import * as getters from "@/store/modules/getters";
import products from "@/store/modules/products";
import companies from "@/store/modules/companies";
import order from "@/store/modules/order";
import bill from "@/store/modules/bill";
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex);

const store = new Vuex.Store();
const strict = false;
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

Vue.use(vuexI18n.plugin, store);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions,
  getters,
  modules: {
    products,
    companies,
    order,
    bill,
  },
  plugins: [vuexLocal.plugin],
  strict,
});
